import * as service from "../service";
import { store } from "../../store";

/**
 * Redeem a coupon with the current student's points.
 * Backend: GET /api/coupon/redeemCoupons/redeemCoupon
 */
export const RedeemCouponAPI = async (coupon_id: string) => {
  const { user } = store.getState().auth as any;
  try {
    const resp = await service.call(
      "GET",
      "api/coupon/redeemCoupons/redeemCoupon",
      {
        coupon_id,
        user_id: user?.id,
      },
    );
    return resp;
  } catch (err) {
    console.error(`RedeemCouponAPI ${err}`);
  }
};
